
<template>
  <div class="my-wrap">
    <ul class="nav-tabs my-mall-exchange-tabs">
      <li :class="{ 'active': $route.path === '/points/all-bonus' }" @click="$router.push('/points/all-bonus')">
        <a>
          {{ $t('Bao.vip_type') }}
        </a>
      </li>
      <li :class="{ 'active': $route.path === '/points/coupon' }" @click="$router.push('/points/coupon')">
        <a>
          {{ $t('Bao.coupon') }}
        </a>
      </li>
    </ul>
    <router-view />
  </div>
</template>

<script>
export default {
  data() {
    return {
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    }
  },
  methods: {

  }
}
</script>

<style scoped>

</style>
